import styled from "styled-components";

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
`;

export const FieldSearchContentMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  height: ${({ theme, isVisible }) => (isVisible ? "100vh" : theme.spacing(7))};
  display: ${({ isVisible }) => (isVisible ? "block" : "flex")};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  position: ${({ isVisible }) => (isVisible ? "fixed" : "inherit")};
  z-index: ${({ isVisible }) => (isVisible ? 1001 : 0)};
  background: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.white : "none"};
  padding: ${({ theme, isVisible }) =>
    isVisible ? "0" : `0 ${theme.spacing(2)}`};
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  top: 0;
  left: 0;
`;

export const FieldSearchHeaderMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  background-color: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.vividBlue : "transparent"};
  padding: ${({ theme, isVisible }) =>
    isVisible ? `${theme.spacing(2)} 0` : 0};
  flex-direction: ${({ isVisible }) => (isVisible ? "column" : "row")};
  height: 100%;
  width: 100%;

  & > div {
    height: ${({ isVisible }) => (isVisible ? "auto" : "inherit")};
    align-items: center;
    display: flex;
  }

  & > button {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
    margin-left: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(2) : 0};
  }

  & > svg {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  }

  & svg {
    color: ${({ theme }) => theme.colors.white};
  }

  & input {
    background-color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.transparent : "inherit"};
    color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.white : theme.colors.darkGray};
    font-size: ${({ theme, isVisible }) =>
      isVisible ? theme.fontSizes.md : "inherit"};
    height: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(6) : "inherit"};
    width: 100%;

    &::placeholder {
      color: ${({ theme, isVisible }) =>
        isVisible ? theme.colors.white : theme.colors.darkGray};
    }
  }
`;

export const FieldSearchMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  height: ${({ isVisible }) => (isVisible ? "auto" : "inherit")};
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  display: flex;
  width: 100%;
  background-color: ${({ isVisible, theme }) =>
    isVisible ? theme.colors.vividBlue : theme.colors.withe};
  /* ${({ theme }) => theme.colors.vividBlue}; */

  & > svg {
    height: ${({ theme }) => theme.spacing(3.2)};
    width: ${({ theme }) => theme.spacing(5.5)};
  }
`;

export const FieldSearchDropdownMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["type"].includes(prop),
})<{ type: string }>`
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;
